import { Point } from 'components/site/general/singleSelect/SelectedMarkerV2/Point';
import { useIsKeyHeld } from 'components/site/general/singleSelect/SelectedMarkerV2/useIsKeyHeld';
import { useLocalConfig } from 'hooks/map/useLocalConfig';
import Draggable from 'react-draggable';
import { IXY } from 'react-give-me-map/dist/utils/map/mapTypes';
import styled from 'styled-components/macro';

interface Props {
    xyCoordinates: IXY[];
    color: string;
    rotation?: number;
    transparent?: boolean;
    disabled?: boolean;
    onDrag?: (point: IXY, index: number) => void;
    onDragEnd?: (point: IXY, index: number) => void;
    onMouseEnter?: () => void;
    onMouseLeave?: () => void;
}
export const DragPoints = (props: Props) => {
    const xyCoordinates = props.xyCoordinates;

    const localConfig = useLocalConfig();
    const [isShiftDown] = useIsKeyHeld('Shift');

    const hiddenPoints = localConfig.useShiftForPolygonUpdate && !isShiftDown;

    return (
        <S_DragPoints $rotation={props.rotation}>
            {xyCoordinates.map((xyCoordinate, i) => {
                const id = xyCoordinate.x + '|' + xyCoordinate.y;
                return (
                    <Draggable
                        key={id}
                        axis="both"
                        handle=".handle"
                        defaultClassName="handleContainer"
                        defaultPosition={xyCoordinate}
                        position={null}
                        disabled={props.disabled}
                        scale={1}
                        onDrag={(_, data) => {
                            const point = { x: data.x, y: data.y };
                            props.onDrag(point, i);
                        }}
                        onStop={(_, data) => {
                            const point = { x: data.x, y: data.y };
                            props.onDragEnd(point, i);
                        }}
                    >
                        <div>
                            <Point
                                className={'handle'}
                                disabled={props.disabled}
                                width={20}
                                fontSize={12}
                                style={{
                                    pointerEvents: 'all',
                                    position: 'relative',
                                    opacity: props.transparent ? 0 : 1,
                                    visibility: hiddenPoints ? 'hidden' : 'visible'
                                }}
                                text={props.disabled ? '' : (i + 1).toString()}
                                color={props.color}
                            />
                        </div>
                    </Draggable>
                );
            })}
        </S_DragPoints>
    );
};

const S_DragPoints = styled.div<{ $rotation: number }>`
    transform: rotate(${(props) => props.$rotation ?? 0}deg);
    transform-origin: center center;
`;
